<script setup>
import $ from "jquery";
import { onMounted } from 'vue';
function slide(elp, elc) {
    var loops = $(elp).attr("attr-loop");
    var slideElm = $(elc);
    var slideHeight = null;

    var childHeight = $(elc).height();//获取子级的内容高度
    var parentHeight = $(elp).height();//获取父级的高度

    //如果子级高度大于父级，不管loop是什么都需要循环，如果子级高度小于父级，需要判断loop是否为true，loop=true  就继续上下无缝滚动
    if (childHeight > parentHeight) {
        slideElm.append(slideElm.html());
        slideHeight = $(elc).height() / 2;

        msgSlide(loopSlide);

    } else {

        if (loops == "true") {
            slideHeight = $(elc).height();
            msgSlide(loopTrueSlide);
        }
    }

    //上下滚动				
    function loopSlide() {

        if (Math.abs($(elc).position().top) > slideHeight) {
            $(elc).css("top", "0px");
        } else {
            $(elc).css("top", $(elc).position().top - 1);
        }
    }

    //loop  为true 时还需要滚动
    function loopTrueSlide() {
        $(elc).css("top", $(elc).position().top - 1);

        if ($(elc).position().top == -slideHeight) {
            $(elc).css("top", $(elp).height());
        }
    }
    //鼠标移入暂停，移出继续
    function msgSlide(fn) {
        var timer = setInterval(fn, 100);
        $(elp).hover(function () {
            clearInterval(timer)
        }, function () {
            timer = setInterval(fn, 100);
        })
    }
}
onMounted(() => {
    slide(".slide-text", ".content")
})
</script>

<template>
    <div class="slide-text" attr-loop="true">
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>
.slide-text {
    margin-top: 10px;
    position: relative;
    height: 250px;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 15px;
    font-weight: 600;
    line-height: 2;
    color: rgba(255, 255, 255, 0.8);
}
.content{
    position: absolute;
}
</style>